// translations/navigation.ts
export const translations = {
  en: {
    'nav.blog': 'Blog',
    'nav.pricing': 'Pricing',
    'nav.profile': 'Profile',
    'nav.signin': 'Sign In',
    'nav.signup': 'Register',
    'nav.convert': 'Convert Invoice',
    'nav.convertMobile': 'Convert',
    'nav.features': 'Features',
    'nav.pdfToXRechnung': 'PDF to XRechnung',
    'nav.xrechnungToPdf': 'XRechnung to PDF',
    'nav.xrechnungViewer': 'XRechnung/XML Viewer',
  },
  de: {
    'nav.blog': 'Blog',
    'nav.pricing': 'Preise',
    'nav.profile': 'Profil',
    'nav.signin': 'Anmelden',
    'nav.signup': 'Registrieren',
    'nav.convert': 'Rechnung konvertieren',
    'nav.convertMobile': 'Konvertieren',
    'nav.features': 'Funktionen',
    'nav.pdfToXRechnung': 'PDF zu XRechnung',
    'nav.xrechnungToPdf': 'XRechnung zu PDF',
    'nav.xrechnungViewer': 'XRechnung/XML Viewer',
  }
};